import { useStyles } from './Loading.styles';
import { TEST_ID_LOADING } from './Loading.constants';
import { LoadingProps } from './Loading.types';

export const Loading = ({ color, fullscreen, size = 'lg' }: LoadingProps) => {
  const styles = useStyles({
    color,
    fullscreen,
    size,
  });

  return (
    <div role="progressbar" data-testid={TEST_ID_LOADING} css={styles.progressBar}>
      <div css={styles.loadingOuterCircle}>
        <div css={styles.loadingAnimation} />
        <div css={styles.loadingInnerCircle} />
      </div>
    </div>
  );
};
